export default class ConfigParameter {

    /**
     *
     * @param paramKey
     * @param inputType
     * @param label
     * @param group
     * @param defaultValue
     * @param units
     * @param options
     * @param validator
     * @param placeholder
     * @param helper
     * @param aclDisable
     */
    constructor(paramKey, inputType, label, group, defaultValue = null, units = null, options = null, validator = null, placeholder = null, helper = null, aclDisable = null) {
        this.paramKey = paramKey;
        this[paramKey] = {
            type: inputType,
            label: label,
            group: group,
            defaultValue: defaultValue,
            units: units,
            options: options,
            validator: validator,
            placeholder: placeholder,
            helper: helper,
            aclDisable: aclDisable
        };
        return this;
    }

    setInputType(inputType) {
        this[this.paramKey].type = inputType;
    }

    setLabel(label) {
        this[this.paramKey].label = label;
    }

    setGroup(group) {
        this[this.paramKey].group = group;
    }

    setDefaultValue(defaultValue) {
        this[this.paramKey].defaultValue = defaultValue;
    }

    setUnits(units) {
        this[this.paramKey].units = units;
    }

    setOptions(options) {
        this[this.paramKey].options = options;
    }

    setValidator(validator) {
        this[this.paramKey].validator = validator;
    }

    setHelper(helper) {
        this[this.paramKey].helper = helper;
    }

    setAclDisable(aclDisable) {
        this[this.paramKey].aclDisable = aclDisable;
    }

}
function gettext(text) {
    return text;
}


export { gettext }


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameter.js